<!--
 * @Description: 登录页
 * @Author: luocheng
 * @Date: 2021-10-25 10:26:07
 * @LastEditors: 朱廷果 1028509503@qq.com
 * @LastEditTime: 2025-11-17 18:45:23
-->
<template>
  <div class="login-index">
    <template v-if="systemConfig && systemConfig.custom_login">
      <!-- 自定义登录页 -->
      <CustomLogin :pageUUID="systemConfig && systemConfig.login_uuid"></CustomLogin>
    </template>
    <template v-else>
      <!-- 葛洲坝 -->
      <GZBIndex v-if="projectEnvironment === 'gzb'"></GZBIndex>
      <!-- 南华 -->
      <NHLogin v-else-if="projectEnvironment === 'nh'"></NHLogin>
      <!-- 濮阳工学院 -->
      <PYGXYLogin v-else-if="projectEnvironment === 'pygxy'"></PYGXYLogin>
      <!-- 中设项目 -->
      <ZSSJZXLogin v-else-if="projectEnvironment === 'zssjzx'"></ZSSJZXLogin>
      <!-- 深圳水务 罗铁 -->
      <LTLogin v-else-if="projectEnvironment === 'ltsd'"></LTLogin>
      <!-- 重庆建工 -->
      <CQJGLogin v-else-if="projectEnvironment === 'cqjg'"></CQJGLogin>
      <!-- 七真安全 -->
      <QZAQLogin v-else-if="projectEnvironment === 'qzaq'"></QZAQLogin>
      <!-- dev -->
      <DevLogin v-else></DevLogin>
    </template>
  </div>
</template>

<script>
import NHLogin from './nh/Index';
import GZBIndex from './gzb/Index';
import DevLogin from './dev/Index.vue';
import PYGXYLogin from './pygxy/Index';
import ZSSJZXLogin from './zssjzx/Index';
import LTLogin from './szsw/Index';
import CQJGLogin from './cqjg/Index';
import CustomLogin from './custom/Index';
import QZAQLogin from './qzaq/Index';
import { mapState } from 'vuex';

export default {
  name: 'Login',
  components: {
    NHLogin,
    GZBIndex,
    DevLogin,
    PYGXYLogin,
    ZSSJZXLogin,
    LTLogin,
    CustomLogin,
    QZAQLogin,
    CQJGLogin
  },
  computed: {
    ...mapState(['projectEnvironment', 'systemConfig'])
  },
}
</script>

<style lang="less" scoped>
.login-index{
  height: 100%;
  width: 100%;
  min-width: 860px;
  min-height: 800px;
  background: #fff;
  overflow: hidden;
  position: relative;
}
</style>